export default __webpack_public_path__ + "static/media/Speaker.577bf6cd.png";